export default __webpack_public_path__ + "static/media/bookdoc-premium-btn.64adbed0.png";